module.exports = __webpack_public_path__ + "res/0-img_mute.2ba1e6ddab1c44ba99b8b32478332005.png";